import { Box, Typography } from "@saviynt/design-system";
import "@saviynt/tokens";
import React, { useEffect, useState } from "react";
import SavContainer from "../../common/SavContainer/SavContainer";
import { Progress } from "antd";
import "./Unseal.css";
import image from "../../../assets/images/vbg-unseal.jpg";

/**
 * Component displaying vault unseal progress.
 * Polls /api/v1/bg/seal-status to track shard count.
 * When vault unseals, parent (LoginUser) handles redirect.
 *
 * @param {Object} props
 * @param {number} props.shardCount - Current number of verified shards
 * @param {number} props.requiredShards - Total shards required (default 3)
 * @returns {JSX.Element}
 */
function Unseal({ shardCount = 0, requiredShards = 3 }) {
  const quorum = requiredShards > 0 ? Math.round((shardCount / requiredShards) * 100) : 0;

  return (
    <SavContainer>
      <img src={image} alt="vbg-unseal" />
      <Box className="Unseal">
        <Box className="Unseal-content">
          <Box className="Unseal-header">
            <Typography kind="h1">Unseal Status</Typography>
          </Box>
          <Typography kind="body" style={{ color: "#ccc", marginBottom: "1rem" }}>
            Custodians verified: {shardCount} of {requiredShards}
          </Typography>
          <Progress
            percent={quorum}
            percentPosition={{ align: "end", type: "inner" }}
            size={["100%", 30]}
            strokeColor="#001342"
            showInfo
          />
          <Typography kind="body" style={{ color: "#999", marginTop: "1rem", textAlign: "center" }}>
            Waiting for remaining custodians to verify...
          </Typography>
        </Box>
      </Box>
    </SavContainer>
  );
}

export default Unseal;
